import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import { toast } from "react-toastify"
import axios from "axios"

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  })
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { adminLogin } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target
    setCredentials({
      ...credentials,
      [name]: value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    toast.success('Hello jee');
    setLoading(true)
    setError("") 

    try {
      await adminLogin(credentials.email, credentials.password);
      navigate('/admin/dashboard');
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.message || "Login failed. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-spiritual-800 to-spiritual-900 flex items-center justify-center px-4">
      <div className="bg-white rounded-lg shadow-xl overflow-hidden max-w-md w-full">
        <div className="bg-spiritual-700 p-6 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4">
            <span className="text-spiritual-700 text-2xl font-bold">DT</span>
          </div>
          <h1 className="text-2xl font-bold text-white">DivyaTemple Admin</h1>
          <p className="text-spiritual-100 mt-1">Sign in to manage temple content</p>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {error && <div className="bg-red-50 text-red-600 p-3 rounded-md text-sm">{error}</div>}

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={credentials.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-spiritual-500 focus:border-spiritual-500"
              placeholder="admin@divyatemple.com"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={credentials.password}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-spiritual-500 focus:border-spiritual-500"
              placeholder="••••••••"
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-2 px-4 rounded-md text-white font-medium transition-colors ${
                loading ? "bg-spiritual-400" : "bg-spiritual-600 hover:bg-spiritual-700"
              }`}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>

          <div className="text-center text-sm text-gray-500">
            <a href="/" className="text-spiritual-600 hover:text-spiritual-800">
              Return to Website
            </a>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AdminLogin